import { message } from 'antd';
import { AxiosInstance } from 'axios';

import { PACKAGE_STATES } from '@/model/Logistic/PackageStates';
import { Shipment } from '@/model/Logistic/Shipment/Shipment';

import ShipmentApi from './ShipmentApi';

class ShipmentRepository {
  shipmentApi: ShipmentApi;

  constructor(axiosInstance: AxiosInstance) {
    this.shipmentApi = new ShipmentApi(axiosInstance);
  }

  updateShipmentState = async (shipmentId: number, newState: PACKAGE_STATES) => {
    try {
      const response = await this.shipmentApi.updateShipmentState(shipmentId, newState);

      message.success('Estado del envío actualizado correctamente');

      return response.data;
    } catch (error) {
      console.error('Error updating shipment state:', error);
      message.error('Error al actualizar el estado del envío');
      throw error;
    }
  };

  updateShipmentExternalDocument = async (shipmentId: number, externalDocument: string) => {
    try {
      const response = await this.shipmentApi.updateShipmentExternalDocument(
        shipmentId,
        externalDocument,
      );

      message.success('Documento externo actualizado correctamente');

      return response.data;
    } catch (error) {
      message.error('Error al actualizar el documento externo');
      throw error;
    }
  };

  updateShipment = async (shipmentId: number, shipmentData: Partial<Shipment>) => {
    try {
      const response = await this.shipmentApi.updateShipment(shipmentId, shipmentData);

      message.success('Envío actualizado correctamente');

      return response;
    } catch (error) {
      message.error('Error al actualizar el envío');
      throw error;
    }
  };
}

export default ShipmentRepository;
